import { Eventbus } from '..';
import logger from '../logger';

export default function mergeUpdatedCollectionData(sourceCollection, targetCollection, options = {}) {

    const idField = options.idField || 'id';
    const event = options.event;
    const filter = options.filter;
    const hardDelete = options.hardDelete || false; // New option for hard deletes
    let updated = false;
    let lastProcessedItem = null;
    [].concat(sourceCollection).filter(function (item) {
        lastProcessedItem = item;

        const existingItem = targetCollection.filter(function (currentItem) {
            return currentItem[idField] === item[idField];
        }).pop();

        // For hard deletes, we handle deletion differently
        if (hardDelete) {
            // If this is a hard delete operation (item has no other properties or is marked for deletion)
            if (item._isDeleted || (Object.keys(item).length === 1 && item[idField])) {
                if (existingItem) {
                    updated = true;
                    const index = targetCollection.map((p) => p[idField]).indexOf(existingItem[idField]);
                    targetCollection.splice(index, 1);
                }
                return true;
            }
        } else {
            // Original soft delete logic
            // ignore if record is older than current
            if (existingItem && existingItem.updatedAt >= item.updatedAt) {
                logger.debug('Ignoring older match record:', item[idField], item);
                return false;
            }

            // ignore if record is deleted and not in collection
            if (!!item.deletedOn && !existingItem) {
                return false;
            }
        }

        // ignore if record is filtered and not in collection
        if (filter) {
            if (filter(item) && !existingItem) {
                return false;
            }
        }

        // an update will be made
        updated = true;

        if (!hardDelete) {
            // remove if record is deleted and in collection (soft delete)
            if ((!!item.deletedOn) && existingItem) {
                const index = targetCollection.map((p) => p[idField]).indexOf(existingItem[idField]);
                targetCollection.splice(index, 1);
                return true;
            }
        }

        // remove if record is filtered and in collection
        if (filter) {
            if (filter(item) && existingItem) {
                const index = targetCollection.map((p) => p[idField]).indexOf(existingItem[idField]);
                targetCollection.splice(index, 1);
                return true;
            }
        }

        // update if record is in collection
        if (existingItem) {
            const index = targetCollection.map((p) => p[idField]).indexOf(existingItem[idField]);
            targetCollection[index] = item;
            return true;
        }
        // add if record is not in collection
        targetCollection.push(item);
        return true;
    });

    if (event && updated) {
        // emit event if collection has been updated
        try {
            Eventbus.emit(event, targetCollection);
        } catch (error) {
            // Log the error and include the last processed item for context
            logger.error('Error emitting updated record:', error, lastProcessedItem);
        }
    }
    return targetCollection;
}